interface Pest {
  name: string;
  description?: string | null;
  translation_key?: string | null;
}

/**
 * Pest names and descriptions are always shown exactly as the admin saved them
 * in the database. We deliberately do NOT translate them per viewer language —
 * if the admin imported the Spanish preset, every user sees Spanish; if the
 * English preset, every user sees English. The hook signature is preserved so
 * existing call sites keep working.
 */
export function usePestTranslation() {
  const getName = (pest: Pest): string => pest.name;
  const getDescription = (pest: Pest): string => pest.description || "";
  return { getName, getDescription };
}
